/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyRemediationActionEnabledQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("PolicyRemediationActionEnabledQueryOperator");
    }

    getFixupPrototypeFunction() { return PolicyRemediationActionEnabledQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<PolicyRemediationActionEnabledQueryOperator>): PolicyRemediationActionEnabledQueryOperator {
        let obj = Object.assign(new PolicyRemediationActionEnabledQueryOperator(), model);
        PolicyRemediationActionEnabledQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyRemediationActionEnabledQueryOperator>): PolicyRemediationActionEnabledQueryOperator {
        if (!model) return null;
        return PolicyRemediationActionEnabledQueryOperator.newInstance(<PolicyRemediationActionEnabledQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyRemediationActionEnabledQueryOperator) {
        if (!obj) return;

        models.PolicyRemediationActionEnabledQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyRemediationActionEnabledQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, PolicyRemediationActionEnabledQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Policy remediation action to include
     */
    is_remediation_action_enabled: boolean;

}
